import { Component } from '@angular/core';
import { Response } from '@angular/http';
import { PasswordService } from '../../api/resources/password.service';

@Component({
  selector: 'recover-password',
  providers: [ PasswordService ],
  styles: [ require('./recover-password.less') ],
  templateUrl: './recover-password.html',
})
export class RecoverPasswordComponent {
  email: string;
  loading: boolean = false;
  recoverError: boolean = false;
  recoverSuccess: boolean = false;
  shakeLogo: boolean = false;

  constructor(private pwService: PasswordService) { }

  public sendRecoveryEmail() {
    this.shakeLogo = false;
    this.loading = true;
    return this.pwService.recoverPassword(this.email)
      .subscribe((res: Response) => {
        this.loading = false;
        this.recoverError = false;
        this.recoverSuccess = true;
      }, (err: any) => {
        console.log(err);
        this.loading = false;
        if (this.recoverError) {
          this.shakeLogo = true;
        } else {
          this.recoverError = true;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/login/recover-password/recover-password.component.ts